import type { ReactNode } from "react";
import { LucideProvider } from "lucide-react";

/**
 * Every lucide icon's line weight: 1.5, lighter than lucide's own 2. The
 * SalefishOS mockup's "Lucide at 1.25" shipped first (Andrew, 2026-11-03) and
 * read too light, light mode especially: "maybe increase them to 1.5 from
 * 1.25" (same day).
 *
 * Set once through lucide's context, at every React root (main.tsx and the
 * harness), so no call site repeats it. A call site that passes its own
 * `strokeWidth` keeps it: those are deliberate (a heavier tick, a status dot).
 * Pinned by tests/iconStroke.test.ts.
 */
export const ICON_STROKE = 1.5;

export function IconStroke({ children }: { children: ReactNode }) {
  return <LucideProvider strokeWidth={ICON_STROKE}>{children}</LucideProvider>;
}
